import axios from '../../api';
import store from '..';

export default {
  namespaced: true,

  state: {
    guests: [],
    guestToEdit: {},
    specificRightsToEdit:{},
    errors: null,
  },
  getters:{
    guests(state){
      return state.guests;
    },
        
    guestToEdit(state){
      return state.guestToEdit;
    },

    specificRightsToEdit(state){
      return state.specificRightsToEdit;
    },

    errors(state){
      return state.errors;
    },
  },
  mutations: {
    SET_GUESTS(state, list){
      state.guests = list;
    },

    SET_GUESTTOEDIT(state, guest){
      state.guestToEdit = {...guest};
    },

    SET_SPECIFICRIGHTSTOEDIT(state, rights){
      state.specificRightsToEdit = rights;
    },

    SET_ERRORS(state, err){
      state.errors = err;
    },
  },

  actions:{
    /**
         * load all guests by particulier
         * @param {*} context 
         */
    async loadGuests(context){
      console.log('wait...loading guests');

      await axios.get('api/invite').then((response) => {
        let guests = response.data;

        context.commit('SET_GUESTS', guests);
      });
    },

    /**
         * Load specifies permission for guest on connected particulier user
         * @param {*} context 
         */
    async loadSpecifiesPermissions(context){
      let guest = context.getters.guestToEdit;

      if(guest != undefined && guest != {}){
        await axios.get('api/loadGuestPermissions/'+guest.id).then((response)=>{
          context.commit('SET_SPECIFICRIGHTSTOEDIT', {rights: {neopassForm: {...response.data}}});
        });
      }
    },

    async saveSpecificRights(context){
      store.commit('permissions/SET_SAVING', true);

      let guest = context.getters.guestToEdit;

      await axios.put('/api/saveGuestPermissions/'+guest.id, {rights: context.getters.specificRightsToEdit.rights.neopassForm}).then(() => {
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'success', msg: 'Les droits spécifiques de '+guest.firstname+' '+guest.lastname+' sur votre Neopass ont bien été enregistrés.'});
        store.commit('permissions/SET_SAVING', false);
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
      }).catch(error => {
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: 'Erreur d`\'enregistrement des données.'});
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
        console.log('ERRRR:: ', error.response.data);
      });
    },

    async deactivateGuest(context){
      store.commit('permissions/SET_SAVING', true);
      let guest = context.getters.guestToEdit;

      await axios.delete('api/deactivateGuest/'+guest.id).then(()=>{
        context.dispatch('loadGuests');
        store.dispatch('auth/me');
        store.commit('permissions/SET_SAVING', false);

        store.commit('permissions/SET_MESSAGEHEADER', {
          type: 'success',
          msg: 'L\'invité '+guest.firstname+' '+guest.lastname+' ne peut plus gérer votre Neopass.'
        });

        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
      }).catch(error => {
        this.SET_MESSAGEHEADER({type: 'error', msg: 'Le benéficiaire n\'a pas pu être enlevé du périmètre du référent'});
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
        console.log('ERRRR:: ', error.response.data);
      });
    },

  },
};